/* eslint-disable prettier/prettier */
import React from 'react';
import { Marker, Popup, Tooltip } from 'react-leaflet';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { REGIONS, REPORT_ICONS } from './constants';

const VehicleMarker = ({ incident, Region, OmniEyescar, icons, formatLocalTime }) => {
    const getIcon = (incident) => {
        if (incident.is_online === "離線") return icons.blackIcon;

        const { reportID } = incident;
        if (REPORT_ICONS.NORMAL.includes(reportID)) return icons.greenIcon;
        if (REPORT_ICONS.SPEED.includes(reportID)) return icons.yellowIcon;
        if (REPORT_ICONS.BRAKE.includes(reportID)) return icons.redIcon;
        if (REPORT_ICONS.TURN.includes(reportID)) return icons.PurpleIcon;
        if (reportID === REPORT_ICONS.POWER) return icons.blueIcon;
        if (reportID === REPORT_ICONS.OFFLINE) return icons.blackIcon;

        return icons.greenIcon;
    };

    const point = [incident.latitude, incident.longitude];
    const icon = getIcon(incident);

    return (
        <Marker position={point} key={incident.FK_UnitID} icon={icon}>
            <Popup>
                <Typography variant="body2" gutterBottom>
                    營運單位:{incident.fleetName}
                </Typography>
                <Typography variant="body2" gutterBottom>
                    車機ID:{incident.fK_UnitID}
                </Typography>
                <Typography variant="body2" gutterBottom>
                    車牌:{incident.identifier}
                </Typography>
                <Typography variant="body2" gutterBottom>
                    狀態:{incident.eventMessage}
                </Typography>
                <Typography variant="body2" gutterBottom>
                    速度:{incident.speed}km/h
                </Typography>
                <Typography variant="body2" gutterBottom>
                    衛星:{incident.satellite}顆
                </Typography>
                <Typography variant="body2" gutterBottom>
                    GPS時間:{formatLocalTime(incident.gpsTime)}
                </Typography>
            </Popup>
            <Tooltip direction="right" offset={[0, 0]} opacity={1} permanent>
                {incident.identifier}
            </Tooltip>
        </Marker>
    );
};

VehicleMarker.propTypes = {
    incident: PropTypes.shape({
        fK_UnitID: PropTypes.string.isRequired,
        identifier: PropTypes.string.isRequired,
        eventMessage: PropTypes.string.isRequired,
        speed: PropTypes.number.isRequired,
        satellite: PropTypes.number.isRequired,
        gpsTime: PropTypes.string.isRequired,
        latitude: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired,
        is_online: PropTypes.string.isRequired,
        reportID: PropTypes.string.isRequired
    }).isRequired,
    Region: PropTypes.string,
    OmniEyescar: PropTypes.bool,
    icons: PropTypes.object.isRequired,
    formatLocalTime: PropTypes.func.isRequired
};

export default VehicleMarker;